import Account from "../components/myAccount";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
const myAccountRoute = [
  {
    path: "account",
    element: <Account />,
    // name: "Account",
    link: "account",
    icon: PeopleAltIcon,
  },
];
export default myAccountRoute;
